lucide.createIcons();

// FAQ Accordion Logic
document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
        const item = q.parentElement;
        item.classList.toggle('active');
    });
});

// Mobile Menu Toggle
document.querySelector('.mobile-menu-btn').addEventListener('click', () => {
    const links = document.querySelector('.nav-links');
    links.classList.toggle('active');
});

// Add scroll effect for navbar
window.addEventListener('scroll', () => {
    const nav = document.querySelector('.navbar');
    if (window.scrollY > 50) {
        nav.style.background = 'rgba(20, 4, 29, 0.98)';
        nav.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.5)';
    } else {
        nav.style.background = 'rgba(20, 4, 29, 0.7)';
        nav.style.boxShadow = 'none';
    }
});
